import * as React from 'react';
import StaticData , { StaticDataGroup } from 'ted-ui/build/StaticData';
import { OrderSummarySection } from './order-summary-section';
import { IOrderDetailsProps } from '@applications/order-tracker/config/order-tracker-new-common/types'
import ActionButton from '@able/react/dist/ActionButton';

export const OrderContactsSection = ({orderSummary}: IOrderDetailsProps) => {

    const renderProjectManagerDetails = () => {
        if (orderSummary.projectManagerContact && orderSummary.telstraProjectCode) {
            return (
                <StaticData
                    name="Telstra order contact"
                    value={[
                        orderSummary.projectManagerContact.name,
                        orderSummary.projectManagerContact.email
                    ]}
                />
            );
        } else {
            return null;
        }
    };

    const renderTelstraConsultantContact = () => {
        if (orderSummary.telstraConsultantContact && orderSummary.telstraProjectCode) {
            return (
                <StaticData
                    name="Telstra order contact"
                    value={[
                        orderSummary.telstraConsultantContact.name,
                        <StaticData
                            key="order-enquiry-action-button-static-data"
                            name=""
                            value={[
                                <ActionButton
                                    key="order-enquiry-action-button"
                                    id="order-enquiry-action-button"
                                    element="Link"
                                    opensNewTab
                                    label="Order enquiry (opens new tab)"
                                    variant="LowEmphasis"
                                    to="https://www.telstra.com.au/forms/fulfilment-delivery-control-order-enquiry"
                                />
                            ]}
                        />,
                    ]}
                />
            );
        } else {
            return null;
        }
    };

    const renderTelstraOrderContact = () => {
        const projectManagerDetails = renderProjectManagerDetails();
        const telstraConsultantContact = renderTelstraConsultantContact();

        if (projectManagerDetails !== null) {
            return projectManagerDetails;
        } else if (telstraConsultantContact !== null) {
            return telstraConsultantContact;
        } else {
            return (
                <StaticData
                    name="Telstra order contact"
                    value="Waiting for information"
                />
            )
        }

    }

    const getCustomerProjectContact = () => {
        if (orderSummary.customerProjectContact && orderSummary.customerProjectContact.name && orderSummary.customerProjectContact.contact) {
            return (
                <StaticData
                    name="Customer project contact"
                    value={[orderSummary.customerProjectContact.name,
                        orderSummary.customerProjectContact.email || null,
                        orderSummary.customerProjectContact.contact
                    ]}
                />
            )
        } else {
            return (
                <StaticData
                name="Customer project contact"
                value="N/A"
                />
            );
        }
    };

    const getCustomerTechnicalContact = () => {
        if (orderSummary.customerTechnicalContact && orderSummary.customerTechnicalContact.name && orderSummary.customerTechnicalContact.contact) {
            return (
                <StaticData
                    name="Customer technical contact"
                    value={[orderSummary.customerTechnicalContact.name,
                        orderSummary.customerTechnicalContact.email || null,
                        orderSummary.customerTechnicalContact.contact
                    ]}
                />
            )
        } else {
            return (
                <StaticData
                    name="Customer technical contact"
                    value="N/A"
                />
            );
        }
    };

    const getGroupOfDescs = (): React.ReactNode => (
        <StaticDataGroup id="order-contact-group-data">
            {renderTelstraOrderContact()}
            {getCustomerProjectContact()}
            {getCustomerTechnicalContact()}
        </StaticDataGroup>
    );

    return (
        <OrderSummarySection
            title="Order contacts"
            descriptionGroup={getGroupOfDescs()}
        />
    )
};
